export enum PreferenceType {
  CantGuardIn = "1",
  CanGuardIn = "2",
  CanAlwaysGuard = "3",
  OneWayFrom = "4",
}

export enum WeekDaysOrDates {
  WeekDays = "1",
  Dates = "2",
}
